import * as React from 'react';
import LockOpenOutlined from './lock-open-outlined';
import LockOpenFilled from './lock-open-filled';
import type { IconCombinedProps } from './types';
const LockOpenCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <LockOpenFilled ref={ref} {...rest} />;
  }
  return <LockOpenOutlined ref={ref} {...rest} />;
});
export default LockOpenCombined;